"use client";
import {
  switch_default
} from "./chunk-6PJTU3P5.mjs";
import {
  useSwitch
} from "./chunk-JDMJDZKU.mjs";
export {
  switch_default as Switch,
  useSwitch
};
